import gesture from "../assets/images/icons/hand.svg";
import SalonActivityLayout from "../components/SalonActivityLayout";
import { useTranslation } from "../components/Localization";

export default function SalonTableTaskPage() {
  const { t } = useTranslation();
  return <SalonActivityLayout taskKey="table" step={1} progressIcon="center" backTo="/szalon/peter" nextTo="/szalon/radio">
    <button className="salon-interaction-panel" aria-label={t("accessibility.tableSetting")}><img src={gesture} alt="" /></button>
  </SalonActivityLayout>;
}
